import type { PropsWithChildren } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@ah/ui';
import { ErrorBoundary } from './ErrorBoundary';
import { DiProvider } from './DiProvider';
import { AppI18nProvider } from './AppI18nProvider';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 2, staleTime: 30_000, refetchOnWindowFocus: false },
  },
});

export function AppProviders({ children }: PropsWithChildren) {
  return (
    <ErrorBoundary>
      <DiProvider>
        <ThemeProvider>
          <QueryClientProvider client={queryClient}>
            <AppI18nProvider>{children}</AppI18nProvider>
          </QueryClientProvider>
        </ThemeProvider>
      </DiProvider>
    </ErrorBoundary>
  );
}
